import {
  Box,
  Chip,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { BrandsContext } from "contexts/Brands";
import { useContext } from "react";
import { BentoBrand, MetadataType } from "schemas/dashboard";

import { DiscoverSearchChipColor } from "utils/color";
import { useSearchBrand } from "utils/useSearchBrand";

import { getMappings } from "./helpers";
import styles from "./styles";

interface Props {
  selectedBrand?: BentoBrand | null;
  header: string;
}

const BrandAnnotation = ({ header, selectedBrand }: Props) => {
  const { requestRecategorization } = useContext(BrandsContext);

  const { handleClickOnTag } = useSearchBrand();
  const mappings = selectedBrand ? getMappings(selectedBrand) : {};

  const renderChip = (
    value: string,
    backgroundColor: string,
    type: MetadataType,
  ) => {
    return (
      <Chip
        component="span"
        key={value?.toString()}
        size="small"
        sx={{
          backgroundColor,
          my: 0.5,
          mx: 0.25,
          fontSize: 11,
        }}
        label={value.replaceAll("_", " ")}
        onClick={(e) =>
          handleClickOnTag(e, {
            type,
            value,
          })
        }
      />
    );
  };

  const displayValue = () => {
    if (!selectedBrand || !(header in mappings)) return <></>;
    const mappingsValue = mappings[header] || {
      key: "",
      color: "",
      metadataType: "",
      isArray: false,
      convertedValue: "",
    };
    // @ts-ignore
    const { key, color, metadataType, isArray, convertedValue } = {
      ...mappingsValue,
    };
    // @ts-ignore
    const values: unknown = selectedBrand[key as keyof BentoBrand];
    if (convertedValue) {
      return convertedValue;
    } else if (isArray && Array.isArray(values)) {
      return values?.map((x: any) =>
        renderChip(x, DiscoverSearchChipColor[color], metadataType),
      );
    } else if (values && typeof values === "string" && values?.length > 0) {
      return renderChip(
        values?.toString(),
        DiscoverSearchChipColor[color],
        metadataType,
      );
    } else {
      return "";
    }
  };

  const value = displayValue();

  return selectedBrand ? (
    <Grid item xs={12}>
      {(value?.length > 0 || mappings?.[header]?.canRecategorize) && (
        <Typography>
          <Box component="span" sx={styles.key}>
            {header}:{" "}
          </Box>{" "}
          <Box sx={styles.value} component="span">
            {displayValue()}
            {mappings?.[header]?.canRecategorize && (
              <Tooltip title="Request recategorization">
                <IconButton
                  sx={{ fontSize: 12 }}
                  onClick={() => requestRecategorization(selectedBrand?.id)}
                >
                  <Box component="i" className="fa-regular fa-refresh" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Typography>
      )}
    </Grid>
  ) : (
    <></>
  );
};

export default BrandAnnotation;
